export default "__VITE_ASSET__KCrUH0vG__"